import { apiGet, apiPost, apiPutId, apiDelete, unwrapPaginated, unwrapData } from './helpers'

const PATH = 'inv/items'

export default {
  listPaginated: (perPage = 10, params = {}, page = 1) =>
    apiGet(`${PATH}/${perPage}`, { ...params, page }).then(unwrapPaginated),
  getById: id => apiGet(`${PATH}/${id}`).then(unwrapData),
  create: data => apiPost(PATH, data),
  update: (id, data) => apiPutId(PATH, id, data),
  remove: id => apiDelete(`${PATH}/${id}`),
}
